/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  Alert, Card, CardBody, Col, Container, FormGroup, Input, Label, Row,
} from 'reactstrap';

// Import Breadcrumb
import Breadcrumb from '../../components/Common/Breadcrumb';
import { put } from '../../helpers/api_helper';
import * as url from '../../helpers/url_helper';
import {
  DEFAULT_TIME_FORMAT,
  TIME_FORMAT_RELATIVE,
  TIME_FORMAT_TIMESTAMP,
  updateStoredPreferences,
} from '../../utilities/timeFormat';

import avatar from '../../assets/images/users/avatar-1.jpg';

function getProfileState(obj) {
  return {
    name: obj.displayName || obj.username || obj.display_name,
    email: obj.email,
    id: obj.id,
    profile_image: obj.profile_image,
    preferences: obj.preferences || {},
  };
}

class UserProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      name: '',
      id: 1,
      profile_image: null,
      preferences: {},
      savingPreferences: false,
      preferenceError: null,
      preferenceSuccess: null,
    };
  }

  componentDidMount() {
    if (localStorage.getItem('authUser')) {
      const obj = JSON.parse(localStorage.getItem('authUser'));
      if (process.env.REACT_APP_DEFAULTAUTH === 'firebase') {
        this.setState(getProfileState(obj));
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === 'fake'
        || process.env.REACT_APP_DEFAULTAUTH === 'jwt'
      ) {
        this.setState(getProfileState(obj));
      }
    }
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, ss) {
    if (this.props !== prevProps) {
      const obj = JSON.parse(localStorage.getItem('authUser'));
      if (process.env.REACT_APP_DEFAULTAUTH === 'firebase') {
        this.setState(getProfileState(obj));
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === 'fake'
        || process.env.REACT_APP_DEFAULTAUTH === 'jwt'
      ) {
        this.setState(getProfileState(obj));
      }
    }
  }

  updateTimeFormat = async (event) => {
    const timeFormat = event.target.value;

    this.setState((state) => ({
      preferences: {
        ...state.preferences,
        time_format: timeFormat,
      },
      savingPreferences: true,
      preferenceError: null,
      preferenceSuccess: null,
    }));

    try {
      const response = await put(url.PUT_USER_PREFERENCES, { time_format: timeFormat });
      const user = updateStoredPreferences(response.preferences);

      this.setState({
        preferences: user.preferences,
        savingPreferences: false,
        preferenceSuccess: 'Preferences saved',
      });
    } catch (error) {
      this.setState({
        savingPreferences: false,
        preferenceError: error.response?.data?.error || error.message,
      });
    }
  };

  render() {
    return (
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title="Dropzone" breadcrumbItem="Profile" />

          <Row>
            <Col lg="12">
              {this.props.error && this.props.error ? (
                <Alert color="danger">{this.props.error}</Alert>
              ) : null}
              {this.props.success && this.props.success ? (
                <Alert color="success">{this.props.success}</Alert>
              ) : null}

              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="me-3">
                      {this.state.profile_image === null && (
                        <img
                          src={avatar}
                          alt=""
                          className="avatar-md rounded-circle img-thumbnail"
                        />
                      )}

                      {this.state.profile_image !== null && (
                        <img
                          src={this.state.profile_image}
                          alt=""
                          className="avatar-md rounded-circle img-thumbnail"
                        />
                      )}
                    </div>
                    <div className="align-self-center flex-1">
                      <div className="text-muted">
                        <h5>{this.state.name}</h5>
                        <p className="mb-1">{this.state.email}</p>
                        <p className="mb-0">
                          ID number:
                          {' '}
                          <strong style={{ fontSize: '24px' }}>{this.state.id}</strong>
                        </p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <h5 className="mb-3">Preferences</h5>
                  {this.state.preferenceError && (
                    <Alert color="danger">{this.state.preferenceError}</Alert>
                  )}
                  {this.state.preferenceSuccess && (
                    <Alert color="success">{this.state.preferenceSuccess}</Alert>
                  )}
                  <FormGroup>
                    <Label for="time_format">Time format</Label>
                    <Input
                      id="time_format"
                      name="time_format"
                      type="select"
                      value={this.state.preferences.time_format || DEFAULT_TIME_FORMAT}
                      onChange={this.updateTimeFormat}
                      disabled={this.state.savingPreferences}
                    >
                      <option value={TIME_FORMAT_RELATIVE}>Relative (x ago)</option>
                      <option value={TIME_FORMAT_TIMESTAMP}>Date timestamp</option>
                    </Input>
                  </FormGroup>
                  <small className="text-muted">
                    {this.state.savingPreferences ? 'Saving...' : 'Changes save automatically'}
                  </small>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

UserProfile.propTypes = {
  error: PropTypes.any,
  success: PropTypes.any,
};

export default UserProfile;
